import * as React from "react";
import * as ReactDOM from "react-dom";
import { differenceInMinutes, format } from "date-fns";
import * as ru from "date-fns/locale/ru";
import classnames from "classnames";
import Tooltip from "rc-tooltip";
import Tag from "../../entryes/panel/students/components/Tag";
import ITag from "../../typings/ITag";
import * as styles from "./styles.scss";

import {
  Card,
  Switch,
  List,
  Star,
  Input,
  Button,
  Form,
  Popup,
  Badge,
  Icon,
} from "../../components";
import { getDateHMDiff, tl } from "../../utils";

import { MUIProfileMenu, themeVariables } from "../../entryes/panel/MUI";
import { Popper } from "@material-ui/core";

interface IProps {
  style?: "danger" | "success";
  fullname: string;
  id?: number;
  courseId?: number;
  tags?: Array<ITag>;
  startDate?: any;
  endDate?: any;
  avatar: string;
  messageFullWidth?: boolean;
  datePrefix?: string;
  datePrefixShort?: string;
  dateBottom?: boolean;
  headerRight?: any;
  profileUrl?: any;
  pmUrl?: any;
  html?: any;
  noMargin?: boolean;
  progress?: any;
  dateTime?: string;
}

export const ListItemComment: React.FC<IProps> =  (props) => {
  const ref = React.useRef(null);
  const [profileMenu, setProfileMenu] = React.useState<HTMLElement>(null);
  const {
    style,
    fullname,
    children,
    html,
    startDate,
    endDate,
    avatar,
    messageFullWidth,
    dateBottom,
    headerRight,
    profileUrl,
    pmUrl,
    datePrefix,
    datePrefixShort,
    noMargin,
    progress,
    dateTime,
  } = props;
  function renderTooltip() {
    if (!("startDate" in props)) {
      return;
    }

    const className = {
      message: classnames({
        [styles.message]: true,
        [styles.messageFullWidth]: props.messageFullWidth,
      }),
      date: classnames({
        [styles.date]: true,
        [styles.dateBottom]: props.dateBottom,
      }),
    };

    const dateFormat = "DD.MM.YYYY HH:mm";

    return (
      <div
        className={className.date}
        title={`Начало: ${format(props.startDate, dateFormat)}
                Конец: ${format(props.endDate, dateFormat)}`}
      >
        <span className="mobile-hide">{props.datePrefix} </span>
        <span className="mobile-only">{props.datePrefixShort} </span>
        {format(props.endDate, dateFormat)}
      </div>
    );
  }

    const date = dateTime
      ? format(dateTime, "DD.MM.YYYY, HH:mm", {
          locale: ru,
        })
      : null;

    const className = {
      message: classnames({
        [styles.message]: true,
        [styles.messageFullWidth]: messageFullWidth,
      }),
      date: classnames({
        [styles.date]: true,
        [styles.dateBottom]: dateBottom,
      }),
      middleHeaderWrapper: classnames({
        [styles.middleHeaderWrapper]: true,
        [styles.short]: progress,
      }),
    };

    const message = html ? (
      <div
        className={className.message}
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      />
    ) : (
      <div className={className.message}>{children}</div>
    );

    const middle = (
      <span className={className.middleHeaderWrapper}>
        <span className={styles.middleHeader}>
          <span
            className={styles.fullname}
            style={{
              color: themeVariables.palette.primary.dark,
            }}
          >
            {profileUrl || pmUrl ? (
              <span style={{cursor: 'pointer'}} ref={ref} onMouseOver={(e) => setProfileMenu(e.currentTarget)} onMouseLeave={() => setProfileMenu(null)}>
                {fullname}
                <Popper 
                  id={"simple-menu" + props.id}
                  open={!!profileMenu}
                  keepMounted
                  placement="bottom"
                  style={{
                    zIndex: 1302
                  }}
                  anchorEl={profileMenu}
                >
                <MUIProfileMenu profileList={[
                  {
                    isShown: !!props.id,
                    label: tl("Профиль"),
                    svgType: "profile",
                    link: `/panel/users/profile/student_id/${props.id}`,
                  },
                  {
                    isShown: !!pmUrl,
                    label: tl("Сообщение"),
                    svgType: "profile-messages",
                    link: pmUrl,
                  },
                  {
                    isShown: !!props.courseId,
                    label: tl("E-mail"),
                    svgType: "courses-email",
                    link: `/panel/sender/send?course_id=${props.courseId}&student_id=${props.id}&condition=specific`,
                  },
                  {
                    isShown: !!props.courseId,
                    label: tl("Дом. задания"),
                    svgType: "nav-homeworks",
                    link: `/panel/homework/students_view?course_id=${props.courseId}&student_id=${props.id}`,
                  },
                  {
                    isShown: false,
                    label: tl("Дневник"),
                    svgType: "nav-diary",
                    link: `/panel/diary/monthcalendar?course_id=${props.courseId}&student_id=${props.id}`,
                  },
                  {
                    isShown: !!props.id,
                    label: tl("Доступ к курсам"),
                    svgType: "nav-courses",
                    link: `/panel/users/coursesaccess/student_id/${props.id}`,
                  },
                  {
                    isShown: !!props.id,
                    label: tl("Файлы ученика"),
                    svgType: "fs-list-filesgroup",
                    link: `/panel/files/courses?course_id=${props.courseId}&section=homeworks&sectionTab=students&student_id=${props.id}`,
                  },
                ]} />
                </Popper>
              </span>
            ) : (
              fullname
            )}
            {date && <span className={styles.fullnameDate}>{date}</span>}
          </span>
          {headerRight ? (
            <div className={styles.afterFullname}>{headerRight}</div>
          ) : null}
        </span>
        <div className={styles.tagContainer}>
        {"tags" in props && props.tags.length > 0 ? (
            props.tags.map((tag: ITag) => (
              <Tag key={tag.id} color={tag.color}>{tag.tag}</Tag>
            ))
        ) : null}
        </div>
        {!dateBottom || <span>{renderTooltip()}</span>}
        {messageFullWidth || message}
      </span>
    );

    const progressHtml = progress === undefined ? (
      ""
    ) : (
      <span
        className={
          styles.middleProgress +
          " " +
          (progress.percentLessonsReady > progress.percentTimeElapsed
            ? "ok"
            : "notok")
        }
      >
        <span className={styles.middleProgressDetails}>
          <span className={styles.middleProgressDetailsLessons}>
            <span>{tl('Пройдено уроков из курса:')}</span>
            <span>{progress.percentLessonsReady}%</span>
          </span>
          <span className={styles.middleProgressDetailsTime}>
            <span>{tl('Прошло времени обучения:')}</span>
            <span>{progress.percentTimeElapsed}%</span>
          </span>
        </span>
        <span className={styles.middleProgressSummary}>
          <span>
            <i />
            {progress.percentLessonsReady > progress.percentTimeElapsed
              ? tl("Успевает")
              : tl("Не успевает")}
          </span>
        </span>
      </span>
    );

    return (
      <List.Item noBorder type={style}>
        <div className={styles.avatarItemWrapper}>
          <div className={styles.avatarItem}>
            <div
              className={styles.avatar}
              style={avatar ? { backgroundImage: `url(${avatar})` } : null}
            />
            {middle}
            {!headerRight && progressHtml}
          </div>
          {!messageFullWidth || message}
        </div>
      </List.Item>
    );
}
